import { render, staticRenderFns } from "./dashboardAnalytics.vue?vue&type=template&id=8de80388"
import script from "./dashboardAnalytics.vue?vue&type=script&lang=js"
export * from "./dashboardAnalytics.vue?vue&type=script&lang=js"
import style0 from "./dashboardAnalytics.vue?vue&type=style&index=0&id=8de80388&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports